import { TranslationNamespace } from '@/i18n';
import { getTranslated } from '@/i18n/get-translated';

import { formatNumber } from '../formatNumber';

import { unitDefinitions } from './unit-converter.config';
import { ConvertOptions, Units } from './unit-converter.types';

const t = getTranslated(TranslationNamespace.Units);

export const convertUnits = (value: number, from: Units, to: Units, options?: ConvertOptions) => {
	const autoScale = options?.autoScale == undefined ? true : options.autoScale;
	const format = options?.format == undefined ? true : options.format;
	const rounding = options?.rounding == undefined ? 1 : options.rounding;

	const fromUnit = unitDefinitions[from];
	const toUnit = unitDefinitions[to];

	if (fromUnit.category !== toUnit.category) {
		throw new Error('Некорректная попытка сконвертировать');
	}

	const inBase = value * fromUnit.factor;
	let result: number;
	let finalUnit: Units;

	if (options?.threshold) {
		const { min, max } = options.threshold;

		if ((min !== undefined && value < min) || (max !== undefined && value > max)) {
			result = value;
			finalUnit = from;
		} else {
			result = inBase / toUnit.factor;
			finalUnit = to;
		}
	} else if (autoScale && value <= toUnit.factor / fromUnit.factor) {
		result = value;
		finalUnit = from;
	} else {
		result = inBase / toUnit.factor;
		finalUnit = to;
	}

	const stringResult = `${formatNumber(Number(result.toFixed(rounding)))} ${t(`${finalUnit}`)}`;

	return format ? stringResult : result;
};
